module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAUCAIAAAAVyRqTAAABWklEQVRIx2P4TzPAAGd9//7906cPd+9c+fPnz9u3r6lm9NMnD758+bxifvHC6dmLZ2R9//7t/t0bEKmAssPmybvJQCCjf/z48fPnj646nyV9unPbVTfMdprc7v/61ZNv374BZeUDNjNYrCAHATW/f/dmwdS0zfN9FrYJ7ZkruLJHcEmP+tJZWa9fPQPKzt18r3/FTTIQyGhg+ALDYX6H8v6Fgje3iBxdJDS7RXbBlNTLF45RIawP7Zq0pE9rwyShjZP4d88R3DLPae6E2M+fPgClNh1+unzXQzIQyOjXr1/eunFuYqvvulluc1pkVk5Umd3j8/XLp5cvnlEa1kAATA/v372YPzl+3qTk3Rubb984d+v6OYiUddoeoOlkIES6BqaTx4/uAcMXmK6BaZGaWYb6uZE8zxIVIGRGETGIvIRFbOKjVViTl4mJyug0DGvyCkxiC1Wa1zJUBwDMsfZR/91q9wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/uy.png
// module id = 952
// module chunks = 0